import { Component, createRef } from 'react';
import { NSBox, NSBoxCombo, NSBoxString, NSButtonBlue, NSColumn, NSDialog } from 'namirasoft-site-react';

export interface QuestionEditDialogProps
{
    current_question: string;
    question_list: string[];
    locked_questions: string[];
    onApply: (new_question: string) => void;
    onClose: () => void;
}

export class QuestionEditDialog extends Component<QuestionEditDialogProps>
{
    private NSBoxCombo_QuestionList = createRef<NSBoxCombo>();
    private NSBoxString_Question = createRef<NSBoxString>();

    constructor(props: QuestionEditDialogProps)
    {
        super(props);
        this.updateQuestion = this.updateQuestion.bind(this);
        this.onComboBoxChanged = this.onComboBoxChanged.bind(this);
        this.onStringBoxChanged = this.onStringBoxChanged.bind(this);
    }

    isAlreadySelected(value: string): boolean
    {
        if (value === this.props.current_question)
            return false;
        return this.props.locked_questions.includes(value);
    }

    updateQuestion()
    {
        try
        {
            let { current_question } = this.props;

            let new_question: string = this.NSBoxString_Question.current?.getValue() ?? "";

            if (!new_question || new_question === current_question)
                this.props.onClose();
            else
                this.props.onApply(new_question);
        }
        catch { }
    }

    onComboBoxChanged(box: NSBoxCombo)
    {
        let value = box.getValueOne();
        if (value)
            this.NSBoxString_Question.current?.setValue(value);
    }

    onStringBoxChanged(box: NSBoxString)
    {
        let combo_box = this.NSBoxCombo_QuestionList.current;
        if (combo_box?.getValueOne() && combo_box.getValueOne() !== box.getValue())
            combo_box.setValueOne(null);
    }

    override render()
    {
        return (
            <NSDialog
                onClose={this.props.onClose}
                center_dialog
            >
                <NSColumn style={{ padding: "1rem 0 0", alignItems: "center" }}>
                    <NSBoxString
                        ref={this.NSBoxString_Question}
                        title="Question"
                        placeholder="Type your question here or edit the selected one"
                        required
                        defaultValue={this.props.current_question}
                        style={{ width: NSBox.width.double }}
                        onChanged={this.onStringBoxChanged}
                        validator={(_, value) => this.isAlreadySelected(value) ? "This question is already one of your security questions." : null}
                    />
                    <NSBoxCombo
                        ref={this.NSBoxCombo_QuestionList}
                        title="Select form a template"
                        placeholder="Please select a question or create your own below"
                        multiple={false}
                        required={false}
                        getOptions={() => this.props.question_list.map((q, i) => ({ value: q, title: `${i + 1}. ${q}` }))}
                        style={{ width: NSBox.width.double }}
                        onChanged={this.onComboBoxChanged}
                    />
                    <NSButtonBlue
                        title="Apply"
                        onClick={{ showLoading: false, action: this.updateQuestion }}
                    />
                </NSColumn>
            </NSDialog>
        )
    }
}

export default QuestionEditDialog